import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ee114d92")

_pushScopeId("data-v-ee114d92")
const _hoisted_1 = { class: "working-style-master-list-container" }
const _hoisted_2 = { class: "mb-8 font-bold font-size-24" }
const _hoisted_3 = { class: "flex items-center mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-2xl" }, null, -1)
const _hoisted_5 = { class: "text-center truncate-2-line" }
const _hoisted_6 = { class: "text-center truncate-2-line" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_Table = _resolveComponent("Table")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('workingStyleMaster')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        class: "w-30 h-10 font-size-16 p-4",
        onClick: _ctx.registerWorkingStyleMaster
      }, {
        default: _withId(() => [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.t('signUp')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", null, [
      _createVNode(_component_Table, {
        headers: _ctx.attendanceDataHeaders,
        data: _ctx.workingStyleMasterData,
        showPagination: true,
        "record-total": _ctx.pagination.total,
        "items-per-pages": _ctx.pagination.per_page,
        currentPage: _ctx.apiWorkingStyleMasterListParams.page,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiWorkingStyleMasterListParams.page = $event)),
        onOnChangePage: _ctx.onChangePage
      }, {
        working_style_code: _withId(({ item }) => [
          _createVNode("div", _hoisted_5, _toDisplayString(item.working_style_code), 1)
        ]),
        working_style_name: _withId(({ item }) => [
          _createVNode("div", _hoisted_6, _toDisplayString(item.working_style_name), 1)
        ]),
        working_style_apply_date: _withId(({ item }) => [
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.displayDate(item.working_style_apply_date)), 1)
        ]),
        edit: _withId(({ item }) => [
          _withDirectives(_createVNode("div", null, [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_BaseIcon, {
                name: "pencil-line",
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.updateWorkingStyleMaster(item))
              }, null, 8, ["onClick"])
            ])
          ], 512), [
            [_directive_tooltip, _ctx.t('actionEdit')]
          ])
        ]),
        remove: _withId(({ item }) => [
          _withDirectives(_createVNode("div", null, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_BaseIcon, {
                name: "trash",
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.removeWorkingStyleMaster(item))
              }, null, 8, ["onClick"])
            ])
          ], 512), [
            [_directive_tooltip, _ctx.t('actionDelete')]
          ])
        ]),
        copy: _withId(({ item }) => [
          _withDirectives(_createVNode("div", null, [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_BaseIcon, {
                name: "copy",
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.copyWorkingStyleMaster(item))
              }, null, 8, ["onClick"])
            ])
          ], 512), [
            [_directive_tooltip, _ctx.t('actionDuplicate')]
          ])
        ]),
        _: 1
      }, 8, ["headers", "data", "record-total", "items-per-pages", "currentPage", "onOnChangePage"])
    ])
  ]))
})